import { useMemo } from 'react';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { keysCamelCaseModifier } from 'hb-react/shared/utils/axiosInterceptors/typescript';

/**
 * Hook that provides default app contexts with camelCase transformation
 * Useful when passing context data to components that expect camelCase properties
 * (e.g., @hivebrite/design-system components)
 */
export const useDefaultAppContextsCamelCase = () => {
  const {
    currentUser,
    currentNetwork,
    currentSession,
    currentAdmin,
    currentUrl,
  } = useDefaultAppContexts();

  const currentUserCamelCase = useMemo(() => {
    if (!currentUser) {
      return undefined;
    }
    return keysCamelCaseModifier(currentUser);
  }, [currentUser]);

  const currentNetworkCamelCase = useMemo(() => {
    if (!currentNetwork) {
      return undefined;
    }
    return keysCamelCaseModifier(currentNetwork);
  }, [currentNetwork]);

  const currentSessionCamelCase = useMemo(() => {
    if (!currentSession) {
      return undefined;
    }
    return keysCamelCaseModifier(currentSession);
  }, [currentSession]);

  const currentAdminCamelCase = useMemo(() => {
    if (!currentAdmin) {
      return undefined;
    }
    return keysCamelCaseModifier(currentAdmin);
  }, [currentAdmin]);

  const currentUrlCamelCase = useMemo(() => {
    if (!currentUrl) {
      return undefined;
    }
    return keysCamelCaseModifier(currentUrl);
  }, [currentUrl]);

  return {
    currentUser: currentUserCamelCase,
    currentNetwork: currentNetworkCamelCase,
    currentSession: currentSessionCamelCase,
    currentAdmin: currentAdminCamelCase,
    currentUrl: currentUrlCamelCase,
  };
};
